var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"root-container-stm"},[_c('div',{key:_vm.$i18n.locale},[(_vm.$route.meta.newLayout)?[_c('TheLayout')]:_c('router-view')],2),_c('dialogs-wrapper')],1)}
var staticRenderFns = []

export { render, staticRenderFns }